var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#arrow-right-circle_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.999 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M.832 10a9.167 9.167 0 1 1 18.333 0A9.167 9.167 0 0 1 .832 10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.41 6.078a.833.833 0 0 1 1.178 0l3.333 3.333a.833.833 0 0 1 0 1.179l-3.333 3.333a.833.833 0 1 1-1.179-1.178L12.153 10 9.41 7.257a.833.833 0 0 1 0-1.179"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.832 10c0-.46.373-.833.833-.833h6.667a.833.833 0 1 1 0 1.667H6.665a.833.833 0 0 1-.833-.833"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow-right-circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
})))));
SvgArrowRightCircle.viewBox = '0 0 20 20';
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightCircle);
export default ForwardRef;